import type { ExcelUploadedFile, PaginatedNext, RecommandationWithRemediation } from '../types';
import { ApiRepository } from './main repository/api.repository';
import { PaginateOptions } from './type';

export type RecommendationsWithRemediationScopes = Array<{
  componentRefId: number;
  componentRefName: string;
  componentRefType: string;
  scopeRefId: number;
  scopeRefName: string;
  version: string;
  versionRefId: number;
}>;

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RecommendationsWithRemediationService {
  const BASE_API = `${window.globalConfiguration.api.base}/v1/recommendation-with-remediation`;

  export const find = async ({ page, limit, filters, sorting }: PaginateOptions) => {
    return ApiRepository.Core().get<PaginatedNext<RecommandationWithRemediation>>(
      `${BASE_API}?page=${page}&limit=${limit}${filters.join('')}${sorting}`
    );
  };

  export const getScopesFiltersValues = async () => {
    return ApiRepository.Core().get<{
      filters: RecommendationsWithRemediationScopes;
    }>(`${BASE_API}/filters/scopes`);
  };

  export const excelDownload = async ({
    filters,
    sendMail,
  }: Pick<PaginateOptions, 'filters'> & { sendMail: boolean }) => {
    return ApiRepository.Core().get<ExcelUploadedFile>(`${BASE_API}/excel?${filters.join('')}`, { sendMail });
  };
}
